module.exports = __webpack_public_path__ + "static/img/zhong10.5e30f09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhong10.png
// module id = JkE9
// module chunks = 16